import {
	BarChart,
	Card,
	DateRangePicker,
	Flex,
	LineChart,
	Tab,
	TabGroup,
	TabList,
	Title,
} from '@tremor/react';

import React, { useState } from 'react';
import { startOfMonth } from 'date-fns';
import APIDataProvider from './api/APIDataProvider';
import api from './api';

const metricTypes = {
	fans: 'Fans',
	following: 'Following',
	online: 'Online',
	payoutPending: 'Pending',
	percentage: 'Percentage',
	unread: 'Unread messages',
};

const fixForMetrics = (sales) =>
	sales.reduce((o, x) => {
		let f = o.find((y) => y.date === x.date);
		if (!f) {
			f = { date: x.date };
			o.push(f);
		}
		f[metricTypes[x.type]] = x.value;
		return o;
	}, []);

const sortForDiff = (sales, doit) =>
	doit
		? sales.map((x, i, a) => {
				const prev = a[i - 1];
				if (prev) {
					return {
						...x,
						value: x.value - prev.value,
					};
				}
				return {
					...x,
					value: 0,
				};
		  })
		: sales;

export default function () {
	const [value, setValue] = useState({
		from: startOfMonth(new Date()),
		to: new Date(),
	});

	const [dateGroup, setDateGroup] = useState(0);
	const [metricIndex, setMetricIndex] = useState(undefined);
	const [chartType, setChartType] = useState(0);
	const [showDiff, setShowDiff] = useState(0);

	const dateGroupNames = ['month', 'week', 'day', 'hour', 'minute'];

	return (
		<>
			<Flex className="mt-6" justifyContent="end">
				<DateRangePicker value={value} onValueChange={setValue} />
			</Flex>
			<APIDataProvider
				method={api.metricsQuery.bind(api)}
				options={{
					from: value.from,
					to: value.to,
					timeGroup: dateGroupNames[dateGroup],
					metric:
						metricIndex === undefined
							? undefined
							: Object.keys(metricTypes)[metricIndex],
				}}
			>
				{(sales) => (
					<Card className="mt-6">
						<Flex justifyContent="between">
							<Title>Metrics</Title>
							<div className="flex">
								<TabGroup
									className="mx-2"
									onIndexChange={setMetricIndex}
									index={metricIndex}
								>
									<TabList className="mt-8" variant="solid">
										{Object.keys(metricTypes).map((k) => (
											<Tab key={k}>{metricTypes[k]}</Tab>
										))}
									</TabList>
								</TabGroup>
								<TabGroup onIndexChange={setChartType} index={chartType}>
									<TabList className="mt-8" variant="solid">
										<Tab>Line</Tab>
										<Tab>Bar</Tab>
									</TabList>
								</TabGroup>
								<TabGroup
									className="mx-2"
									onIndexChange={setShowDiff}
									index={showDiff}
								>
									<TabList className="mt-8" variant="solid">
										<Tab>Normal</Tab>
										<Tab>Diff</Tab>
									</TabList>
								</TabGroup>
							</div>
						</Flex>
						<TabGroup onIndexChange={setDateGroup} index={dateGroup}>
							<TabList className="mt-8">
								<Tab>Month</Tab>
								<Tab>Week</Tab>
								<Tab>Day</Tab>
								<Tab>Hour</Tab>
								<Tab>Minute</Tab>
							</TabList>
						</TabGroup>
						{!chartType ? (
							<LineChart
								data={sortForDiff(
									metricIndex === undefined
										? fixForMetrics(sales || [])
										: sales,
									showDiff
								)}
								categories={
									metricIndex === undefined
										? Object.values(metricTypes)
										: ['value']
								}
								index="date"
							/>
						) : (
							<BarChart
								data={sortForDiff(
									metricIndex === undefined
										? fixForMetrics(sales || [])
										: sales,
									showDiff
								)}
								categories={
									metricIndex === undefined
										? Object.values(metricTypes)
										: ['value']
								}
								index="date"
							/>
						)}
					</Card>
				)}
			</APIDataProvider>
		</>
	);
}
